import type { Field } from "../types";

const DEFAULT_CONFIG: Field[] = ["firstName", "lastName", "email", "password"];

const configs: Record<string, Field[]> = {
    JP: [
        "lastName",
        "firstName",
        "phoneticLastName",
        "phoneticFirstName",
        "dateOfBirth",
        "email",
        "password",
    ],
};

export const getConfig = (country: string) => configs[country] ?? DEFAULT_CONFIG;
